import { useBranding } from "@/lib/branding";
import { imageUrl } from "@/lib/siteContent";

export function Brand({ dark, small }) {
  const { logo_url } = useBranding();
  if (logo_url) {
    return <img data-testid="brand-logo" src={imageUrl(logo_url)} alt="KitchenAudit.app" className={`${small ? "h-7" : "h-9"} max-w-[180px] object-contain ${dark ? "rounded-md bg-white px-1.5 py-1" : ""}`} />;
  }
  return (
    <>
      {!small && <img src="/icon-192.png" alt="" className="h-8 w-8 rounded-lg" />}
      <span className={`font-display font-extrabold ${small ? "text-base" : "text-lg"} ${dark ? "text-white" : ""}`}>KitchenAudit<span className={dark ? "text-emerald-400" : "text-emerald-600"}>.app</span></span>
    </>
  );
}
